/** Enum to manage Zones, Dialyse and Endoscope progression */
export enum ETaskStatus {
    New,
    InProgress,
    Done
}